import { render, staticRenderFns } from "./consultationDes.vue?vue&type=template&id=505dd9ca&scoped=true&"
import script from "./consultationDes.vue?vue&type=script&lang=js&"
export * from "./consultationDes.vue?vue&type=script&lang=js&"
import style0 from "./consultationDes.vue?vue&type=style&index=0&id=505dd9ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505dd9ca",
  null
  
)

export default component.exports